// tslint:disable:max-line-length

import React from 'react';

export const ActionMove = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0L5,3h2v4H3V5L0,8l3,3V9h4v4H5l2,2l1,1l1-1l2-2H9V9h4v2l3-3l-3-3v2H9V3h2L8,0z" />
    </svg>
  );
};
